/**
 * Block: image-carousel, config.
 */

import { Mousewheel } from 'swiper';

export const swiperConfig = {
	autoplay: {
		pauseOnMouseEnter: true,
		disableOnInteraction: false,
	},
	centerInsufficientSlides: true,
	centeredSlides: true,
	centeredSlidesBounds: true,
	loop: false,
	loopedSlides: 1,
	modules: [Mousewheel],
	mousewheel: {
		forceToAxis: true,
	},
	navigation: {
		prevEl: '.swiper-button-prev',
		nextEl: '.swiper-button-next',
	},
	pagination: {
		el: '.swiper-pagination',
		clickable: true,
	},
	slideClass: 'wp-block-image',
	slidesPerView: 'auto',
	spaceBetween: 16,
};
